import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {ZadApiError} from '../zad/errors'
import {fetchZadIssuerProfile, updateZadIssuerProfile, uploadZadIssuerLogo} from './service'
import {ZadIssuerProfileState} from './types'

const initialState: ZadIssuerProfileState = {
  profile: null,
  loading: false,
  saveLoading: false,
  logoLoading: false,
  error: null,
  errorCode: null,
  errorStatus: null,
}

function applyRejected(state: ZadIssuerProfileState, action: PayloadAction<any>) {
  const payload = (action.payload || {}) as ZadApiError
  state.error = payload.error || 'Request failed'
  state.errorCode = payload.errorCode || null
  state.errorStatus = payload.status || null
}

function clearError(state: ZadIssuerProfileState) {
  state.error = null
  state.errorCode = null
  state.errorStatus = null
}

const zadIssuerProfileSlice = createSlice({
  name: 'zadIssuerProfile',
  initialState,
  reducers: {
    clearZadIssuerProfileError: (state) => {
      clearError(state)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchZadIssuerProfile.pending, (state) => {
      state.loading = true
      clearError(state)
    })
    builder.addCase(fetchZadIssuerProfile.rejected, (state, action: PayloadAction<any>) => {
      applyRejected(state, action)
      state.loading = false
    })
    builder.addCase(fetchZadIssuerProfile.fulfilled, (state, action) => {
      state.loading = false
      clearError(state)
      state.profile = action.payload.profile
    })

    builder.addCase(updateZadIssuerProfile.pending, (state) => {
      state.saveLoading = true
      clearError(state)
    })
    builder.addCase(updateZadIssuerProfile.rejected, (state, action: PayloadAction<any>) => {
      applyRejected(state, action)
      state.saveLoading = false
    })
    builder.addCase(updateZadIssuerProfile.fulfilled, (state, action) => {
      state.saveLoading = false
      clearError(state)
      state.profile = action.payload.profile
    })

    builder.addCase(uploadZadIssuerLogo.pending, (state) => {
      state.logoLoading = true
      clearError(state)
    })
    builder.addCase(uploadZadIssuerLogo.rejected, (state, action: PayloadAction<any>) => {
      applyRejected(state, action)
      state.logoLoading = false
    })
    builder.addCase(uploadZadIssuerLogo.fulfilled, (state, action) => {
      state.logoLoading = false
      clearError(state)
      state.profile = {
        ...(state.profile || {}),
        ...action.payload.profile,
      }
    })
  },
})

export default zadIssuerProfileSlice.reducer
export const actions = zadIssuerProfileSlice.actions
export {initialState as zadIssuerProfileInitialState}
